import scalpePro from '@/assets/products/scalpe-pro.png';
import hydraboost from '@/assets/products/hydraboost.png';
import revitalize from '@/assets/products/revitalize.png';
import brightenup from '@/assets/products/brightenup.png';
import purenature from '@/assets/products/purenature.png';
import deepclean from '@/assets/products/deepclean.png';

/**
 * Catalogue imagery is not part of the analytics feed, so SKU thumbnails are
 * resolved locally by name. Replace with a catalogue lookup once product media
 * is available; until then an unmatched SKU simply renders without a thumb,
 * which the layout already handles.
 */
const BY_NAME: Array<[RegExp, string]> = [
  [/scalpe/i, scalpePro],
  [/hydraboost/i, hydraboost],
  [/revitalize/i, revitalize],
  [/brightenup/i, brightenup],
  [/purenature/i, purenature],
  [/deepclean/i, deepclean],
];

export function productImage(label: string): string | undefined {
  return BY_NAME.find(([re]) => re.test(label))?.[1];
}
